"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var CONTAINER_HTML = '<div contenteditable style="width: 1px; height: 1px; overflow: hidden; position: fixed; top: 0; left; 0; -webkit-user-select: text"></div>';
/**
 * Core paste plugin for handling onPaste event and extract the pasted content
 */
var CorePastePlugin = /** @class */ (function () {
    function CorePastePlugin() {
        var _this = this;
        this.onPaste = function (event) {
            roosterjs_editor_dom_1.extractClipboardEvent(event, function (items) {
                if (items.html === undefined) {
                    // Can't get pasted HTML directly, need to use a temp DIV to retrieve pasted content.
                    // This is mostly for IE
                    var originalSelectionRange_1 = _this.editor.getSelectionRange();
                    var tempDiv_1 = _this.editor.getCustomData('PasteDiv', _this.createTempDivForIE, function (pasteDiv) { return pasteDiv.parentNode.removeChild(pasteDiv); });
                    tempDiv_1.style.display = '';
                    tempDiv_1.focus();
                    _this.editor.runAsync(function () {
                        // restore original selection range in editor
                        _this.editor.select(originalSelectionRange_1);
                        items.html = tempDiv_1.innerHTML;
                        tempDiv_1.style.display = 'none';
                        tempDiv_1.innerHTML = '';
                        _this.paste(items);
                    });
                }
                else {
                    _this.paste(items);
                }
            });
        };
        this.createTempDivForIE = function () {
            var pasteDiv = roosterjs_editor_dom_1.fromHtml(CONTAINER_HTML, _this.editor.getDocument())[0];
            _this.editor.insertNode(pasteDiv, {
                position: 4 /* Outside */,
            });
            return pasteDiv;
        };
    }
    CorePastePlugin.prototype.getName = function () {
        return 'CorePaste';
    };
    CorePastePlugin.prototype.initialize = function (editor) {
        this.editor = editor;
        this.disposer = this.editor.addDomEventHandler('paste', this.onPaste);
    };
    CorePastePlugin.prototype.dispose = function () {
        this.disposer();
        this.disposer = null;
        this.editor = null;
    };
    CorePastePlugin.prototype.paste = function (items) {
        var _this = this;
        var clipboardData = {
            types: items.types,
            image: items.image,
            text: items.text,
            rawHtml: items.html,
            // Will be set later
            snapshotBeforePaste: null,
            imageDataUri: null,
            // TODO: deprecated properties
            html: null,
            originalFormat: null,
        };
        if (clipboardData.image) {
            var reader_1 = new FileReader();
            reader_1.onload = function () {
                clipboardData.imageDataUri = reader_1.result;
                _this.editor.paste(clipboardData);
            };
            reader_1.onerror = function () {
                clipboardData.image = null;
                _this.editor.paste(clipboardData);
            };
            reader_1.readAsDataURL(clipboardData.image);
        }
        else {
            this.editor.paste(clipboardData);
        }
    };
    return CorePastePlugin;
}());
exports.default = CorePastePlugin;
//# sourceMappingURL=CorePastePlugin.js.map